export default __webpack_public_path__ + "static/media/logo_nova_light.8df613d7.png";